<template>
  <div v-if="hasStoriesLeft && !underage">
    <g-title size="m" tag="h2">{{ storyEndPage.SelectionTitle }}</g-title>
    <g-markdown :content="storyEndPage.SelectionText" />

    <g-button @click="next()">
      {{
        this.hasEnteredAdditionalInfo
          ? 'Gå vidare till nästa berättelse'
          : 'Fortsätt testet'
      }}
    </g-button>
  </div>
  <div v-else>
    <g-title size="m" tag="h2">{{ storyEndPage.FinishTitle }}</g-title>
    <g-markdown :content="storyEndPage.FinishText" />
    <router-link to="/">
      <g-button>Startsidan</g-button>
    </router-link>
  </div>
</template>

<script>
import GET_STORY_END_PAGE from '@/graphql/story/GetStoryEndPage.gql';

export default {
  apollo: {
    storyEndPage: {
      query: GET_STORY_END_PAGE
    }
  },
  data() {
    return {
      hasEnteredAdditionalInfo: false,
      storyEndPage: {
        SelectionTitle: '',
        SelectionText: '',
        FinishTitle: '',
        FinishText: ''
      },
      underage: false
    };
  },
  computed: {
    remainingStories() {
      const stories = JSON.parse(window.sessionStorage.getItem('story-loop'));
      if (stories) {
        return stories;
      } else {
        return [];
      }
    },
    hasStoriesLeft() {
      const stories = JSON.parse(window.sessionStorage.getItem('story-loop'));
      return stories && stories.length > 0;
    }
  },
  beforeMount() {
    this.underage = this.$route.query.underage;
  },
  created() {
    const userObj = JSON.parse(window.sessionStorage.getItem('userObject'));
    if (userObj.hasOwnProperty('enteredAdditional')) {
      this.hasEnteredAdditionalInfo = userObj.enteredAdditional;
    }
  },
  methods: {
    next() {
      if (!this.hasStoriesLeft) return;

      const nextStory = this.remainingStories[0];

      if (this.hasEnteredAdditionalInfo) {
        this.$router.push({ name: 'story', params: { id: nextStory.id } });
      } else {
        this.$router.push({
          name: 'story-additional',
          params: { id: nextStory.id }
        });
      }
    },
    formatStoryTitleLabel(title) {
      let t = title.split(':');

      return t[t.length - 1].trim();
    }
  }
};
</script>

<style lang="scss" scoped></style>
